import { useState, type ReactNode } from 'react';

/** Ladrillitos apilados: fundador (colores de la marca). */
function Bricks() {
  return (
    <svg viewBox="0 0 24 20" width="18" height="15" aria-hidden="true" focusable="false">
      <rect x="1" y="12" width="10" height="6.5" rx="1.2" fill="var(--brand-leaf, #3f7f86)" />
      <rect x="13" y="12" width="10" height="6.5" rx="1.2" fill="var(--color-accent, #d9a65a)" />
      <rect x="7" y="4.5" width="10" height="6.5" rx="1.2" fill="var(--brand-cross, #1f3440)" />
    </svg>
  );
}

/** Cruz negra: finado. */
function Cross() {
  return (
    <svg viewBox="0 0 16 22" width="12" height="16" aria-hidden="true" focusable="false">
      <rect x="6.3" y="1" width="3.4" height="20" rx="0.6" fill="#111" />
      <rect x="1.5" y="6" width="13" height="3.4" rx="0.6" fill="#111" />
    </svg>
  );
}

/**
 * Ícono de fundador (ladrillitos) y de finado (cruz) junto a un nombre. Al pasar el mouse dice qué
 * significa; en el celular se lee al tocar el ícono.
 */
export function LegacyBadges({ founder, deceased = false, deceasedYear = null }: { founder: 'pastor' | 'miembro' | null | undefined; deceased?: boolean; deceasedYear?: number | null }) {
  const [shown, setShown] = useState<string | null>(null);
  const items: { key: string; label: string; icon: ReactNode }[] = [];
  if (founder) items.push({ key: 'f', label: founder === 'pastor' ? 'Pastor fundador' : 'Miembro fundador', icon: <Bricks /> });
  if (deceased) items.push({ key: 'd', label: deceasedYear ? `Finado (${deceasedYear})` : 'Finado', icon: <Cross /> });
  if (items.length === 0) return null;
  return (
    <span className="legacy">
      {items.map((i) => (
        <button key={i.key} type="button" className="legacy__icon" title={i.label} aria-label={i.label} onClick={(e) => { e.preventDefault(); e.stopPropagation(); setShown(shown === i.label ? null : i.label); }}>
          {i.icon}
        </button>
      ))}
      {shown ? (
        <span className="legacy__label small" role="status">
          {shown}
        </span>
      ) : null}
    </span>
  );
}
